export default "__VITE_ASSET__6b05c190__"